<template>
  <div class="Aboutus">
    <div class="container_">
      <section class="cv-inner-banner-wrapper">
        <div class="cv-container">
          <h2 class="cv-page-section-title">About Us</h2>
          <p>
            Our company was founded in 2004 and is a company specializing in the
            research, development, and manufacturing of high-tech products. We
            possess advanced production equipment and a professional technical
            team, and are committed to providing our customers with the highest
            quality products and services.
          </p>
        </div>
      </section>

      <div class="container">
        <!-- 关于我们 -->
        <section class="section" id="about">
          <h2>About Us</h2>
          <div class="about-content">
            <div class="about-text">
              <div class="fl-rich-text">
                <p>
                  Deer Gift Co., LTD is a professional manufacturer of various
                  gifts and crafts, located in Zhongshan, Guangdong, China,
                  since 2004.<br />
                  Our main product lines include metal products as Key chains,
                  badges, emblems, medals, coins, lapel pins, bottle opener,
                  medallions, name tags, belt buckle, fridge magnet, souvenirs;
                  and other products include leather, soft PVC, and fabric
                  products etc.<br />
                  With over 17 years’ experience working with professional
                  buyers all over the world, which enable us developed a keen
                  insight into customer needs, and capable to provide the best
                  solution to meet their satisfaction rapidly.
                </p>
                <!-- <p>
                  As a manufacturer integrating development and production
                  together, we have built up a complete strict quality control
                  system, that covers all processes from raw material
                  inspection, molding, stamping, die casting, polishing,
                  coloring, to packing. Plus promoting the management follows
                  EN71 and CE standard, that enable us to provide products with
                  competitive price, reliable quality and punctual delivery.
                </p> -->
                <p>
                  Our core value is integrity, responsibility, efficiency and
                  innovation. Come and share your idea with us, and we are sure
                  you will find us a great partner to work with.
                </p>
              </div>
            </div>
            <div class="about-image">
              <img
                src="https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                alt="企业形象"
              />
            </div>
          </div>

          <div class="stats">
            <div class="stat-item">
              <div class="stat-number" id="years">21</div>
              <div class="stat-text">Years of industry experience</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" id="employees">100</div>
              <div class="stat-text">Professional employees</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" id="clients">10000</div>
              <div class="stat-text">Served customers</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" id="countries">30</div>
              <div class="stat-text">Country/Region</div>
            </div>
          </div>
        </section>

        <!-- 产品服务 -->
        <section class="section" id="products">
          <h2>Products and Services</h2>
          <div class="products">
            <div class="product">
              <div class="product-image">
                <img src="@/assets/aa-11.png" alt="智能设备" />
              </div>
              <div class="product-info">
                <h3 class="product-name">Smart devices</h3>
                <p class="product-desc">
                  Utilizing smart devices with the latest technology to improve
                  production efficiency and reduce operating costs.
                </p>
              </div>
            </div>

            <div class="product">
              <div class="product-image">
                <img src="@/assets/aa-10.png" alt="工业解决方案" />
              </div>
              <div class="product-info">
                <h3 class="product-name">Industrial Solutions</h3>
                <p class="product-desc">
                  We provide customized solutions that better meet our
                  customers' needs.
                </p>
              </div>
            </div>

            <div class="product">
              <div class="product-image">
                <img src="@/assets/aa-9.png" alt="技术支持" />
              </div>
              <div class="product-info">
                <h3 class="product-name">Technical support</h3>
                <p class="product-desc">
                  We provide 24/7 technical support and after-sales service to
                  ensure our customers have peace of mind.
                </p>
              </div>
            </div>
          </div>
        </section>

        <!-- 联系我们 -->
        <!-- <section class="section" id="contact">
          <h2>Contact</h2>
          <div class="contact-content">
            <div class="contact-info">
              <h3>Contact Information</h3>

              <div class="contact-detail">
                <i class="fas fa-map-marker-alt"></i>
                <div>
                  <span>
                    ZHONGSHAN DEERGIFTS METAL PRODUCT CO., LTD. No. 9, Lane 21,
                    Tong'an Avenue East Road, Tong'an Village, Dongfeng,
                    Zhongshan , Guangdong, China.
                  </span>
                </div>
              </div>

              <div class="contact-detail">
                <i class="fas fa-phone"></i>
                <div>
                  <p>86-13715691313</p>
                </div>
              </div>

              <div class="contact-detail">
                <i class="fas fa-envelope"></i>
                <div>
                  <p>info@deergifts.com</p>
                </div>
              </div>

              <div class="contact-detail">
                <i class="fas fa-clock"></i>
                <div>
                  <p>Twenty-four seven</p>
                </div>
              </div>
            </div>

            <div class="contact-form">
              <h3>发送消息</h3>
              <form>
                <input type="text" placeholder="您的姓名" />
                <input type="email" placeholder="您的邮箱" />
                <input type="text" placeholder="主题" />
                <textarea placeholder="您的消息"></textarea>
                <button type="submit" class="btn">发送消息</button>
              </form>
            </div>
          </div>
        </section> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Aboutus',
  components: {},
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cv-inner-banner-wrapper {
  /* background: url(../images/wave-background.png) center bottom no-repeat; */
  background-image: url('~@/assets/wave-background.png');
  background-size: cover;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 300px;
  color: #fff;
}

.cv-container {
  width: 1350px;
  margin: 100px auto 10px auto;
}

.cv-inner-banner-wrapper h2 {
  margin-bottom: 10px;
  /* color: #fff; */
}

.cv-inner-banner-wrapper p {
  width: 60%;
  margin: 0 auto;
  line-height: 2;
  font-size: 15px;
  margin-bottom: 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  margin-top: -220px;
}

/* 内容区块 */
.section {
  background: white;
  border-radius: 10px;
  padding: 40px;
  margin-bottom: 40px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.section h2 {
  color: #b71c1c;
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ff5252;
  font-size: 2rem;
}

/* 关于我们 */
.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  align-items: center;
}

.about-text p {
  margin-bottom: 15px;
  line-height: 1.8;
  color: #555;
}

.about-image {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.about-image img {
  width: 100%;
  height: auto;
  display: block;
}

/* 数据统计 */
.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin: 40px 0;
}

.stat-item {
  text-align: center;
  padding: 30px 20px;
  background: linear-gradient(to bottom right, #b71c1c, #d32f2f);
  color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(183, 28, 28, 0.3);
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.stat-text {
  font-size: 1.1rem;
}

/* 团队展示 */
.team {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
}

.team-member {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: transform 0.3s ease;
  border-top: 3px solid #d32f2f;
}

.team-member:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(183, 28, 28, 0.15);
}

.member-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 15px;
  border: 3px solid #d32f2f;
}

.member-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.member-name {
  color: #b71c1c;
  margin-bottom: 5px;
  font-weight: bold;
}

.member-role {
  color: #777;
  margin-bottom: 15px;
}

/* 产品展示 */
.products {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
}

.product {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.product:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(183, 28, 28, 0.2);
}

.product-image {
  height: 200px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.product:hover .product-image img {
  transform: scale(1.05);
}

.product-info {
  padding: 20px;
  background: white;
}

.product-name {
  color: #b71c1c;
  margin-bottom: 10px;
  font-size: 1.2rem;
}

.product-desc {
  color: #666;
  line-height: 1.6;
}

/* 联系表单 */
.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.contact-info {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
}

.contact-info h3 {
  color: #b71c1c;
  margin-bottom: 20px;
}

.contact-detail {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.contact-detail i {
  width: 40px !important;
  height: 40px;
  background: #d32f2f;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
}

.contact-form textarea {
  min-height: 120px;
  resize: vertical;
}

.btn {
  background: #d32f2f;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.3s ease;
}

.btn:hover {
  background: #b71c1c;
}

/* 地图 */
#map {
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  margin-top: 30px;
  border: 1px solid #ddd;
}

/* 页脚 */
footer {
  background: #b71c1c;
  color: white;
  padding: 40px 0;
  margin-top: 60px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.footer-section h3 {
  margin-bottom: 20px;
  font-size: 1.2rem;
}

.footer-links {
  list-style: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: white;
}

.social-links {
  display: flex;
  gap: 15px;
  margin-top: 15px;
}

.social-links a {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  transition: background 0.3s ease;
}

.social-links a:hover {
  background: rgba(255, 255, 255, 0.2);
}

.copyright {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/page/aboutus/Aboutus.vue